import http from "../http";

export default (axios, base) => ({
  login: (page = 1, pageSize = 15) => http.get(`${base}/login?page=${page}&per_page=${pageSize}`),
  cash: (page = 1, pageSize = 15) => http.get(`${base}/cash?page=${page}&per_page${pageSize}`),
  onlineMember: (startDate, endDate) => http.get(`${base}/online_member?start_date=${startDate}&end_date=${endDate}`),
});
